import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-header-logo-only',
  templateUrl: './public-header-logo-only.component.html',
  styleUrls: ['./public-header-logo-only.component.scss']
})
export class PublicHeaderLogoOnlyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
